module.exports = __webpack_public_path__ + "img/79.c3a3be80.jpg";